<ng-container *ngIf="!isUserLoggedIn">
  <div
    *ngIf="error?.status"
    class="color-orange u-margin-center"
    [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="52px" fxLayout="row" fxLayoutAlign="start center">
        <i
          class="material-icons color-orange"
          [ngStyle]="{ 'font-size': '36px' }"
        >
          error
        </i>
      </div>
      <div i18n="@@loginView.linkExpiredError" fxFlex="100">
        It seems like the link you tried to use is either invalid or expired.
        Request a new login link to access your account.
      </div>
    </div>
  </div>
  <div
    *ngIf="isLoggingIn"
    class="u-margin-center"
    [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="52px" fxLayout="row" fxLayoutAlign="start center">
        <app-progress-spinner class="u-display-block"></app-progress-spinner>
      </div>
      <div i18n="@@loginView.loggingInText" fxFlex="100">Verifying...</div>
    </div>
  </div>
  <div
    *ngIf="!userAuthService.isLoggedIn()"
    class="bg-color-white u-card u-margin-center u-marginTop-24 u-padding-24 mat-elevation-z1"
    [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
    [ngSwitch]="viewMode"
  >
    <ng-container *ngSwitchCase="VIEW_MODES.enterEmail">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="u-marginBottom-24"
      >
        <app-avatar-tenant
          *ngIf="tenant"
          class="u-display-block"
          [item]="tenant"
          [size]="96"
        >
        </app-avatar-tenant>
      </div>
      <h6
        i18n="@@loginView.enterEmailView.title"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="u-paddingBottom-16"
      >
        Log in
        <ng-container *ngIf="tenant?.friendly_name">
          to {{ tenant?.friendly_name }}
        </ng-container>
      </h6>
      <ng-container *ngIf="!showSSOButton">
        <p
          i18n="@@loginView.enterEmailView.loginPrompt"
          class="u-marginBottom-16 color-grey-300"
        >
          Enter your email and we'll send you a link to access your profile.
        </p>
        <form
          [formGroup]="loginForm"
          novalidate
          (ngSubmit)="sendEmail(loginForm)"
        >
          <div class="u-marginBottom-8">
            <mat-form-field class="mat-form-field-width-100">
              <mat-label i18n="@@global.email">Email</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                autocomplete="off"
                required
              />
              <app-progress-spinner
                *ngIf="isLoading"
                class="u-display-block u-marginRight-16"
                matSuffix
              >
              </app-progress-spinner>
            </mat-form-field>
            <p
              *ngIf="loginForm?.errors?.server"
              class="text-caption color-orange"
            >
              <ng-container i18n="@@loginView.enterEmailView.serverError"
                >{ loginForm?.errors?.server, select, other
                {{{ loginForm?.errors?.server }}} }</ng-container
              >
            </p>
          </div>
          <div
            class="u-paddingBottom-24"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <button
              i18n="@@loginView.enterEmailView.sendCta"
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="isLoading || !loginForm.valid || isLoggingIn"
            >
              Send Link
            </button>
          </div>
        </form>
        <p
          *ngIf="tenant.integrations?.workos?.sso_login_enabled"
          i18n="@@loginView.enterEmailView.loginWithSSOPrompt"
          class="color-grey-300"
        >
          Or,
          <button
            class="c-button color-blue"
            (click)="showSSOButton = true"
            type="button"
          >
            use your team's Single sign-on authentication</button
          >.
        </p>
      </ng-container>
      <ng-container *ngIf="showSSOButton">
        <app-sso-signin
          [ssoErrorMessage]="ssoErrorMessage"
          [ssoErrorStatus]="ssoErrorStatus"
          [ssoSignInParams]="ssoSignInParams"
          [tenant]="tenant"
          class="u-display-block"
        ></app-sso-signin>
        <p
          *ngIf="tenant.email_login_enabled"
          i18n="@@loginView.enterEmailView.loginWithEmailPrompt"
          class="color-grey-300"
        >
          Or,
          <button
            class="c-button color-blue"
            (click)="showSSOButton = false"
            type="button"
          >
            use a magic link via your email address</button
          >.
        </p>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="VIEW_MODES.emailSent">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        class="u-marginBottom-24"
      >
        <app-avatar-tenant
          *ngIf="tenant"
          class="u-display-block"
          [item]="tenant"
          [size]="96"
        >
        </app-avatar-tenant>
      </div>
      <h6 i18n="@@loginView.emailSentView.title" class="u-paddingBottom-16">
        Check your email!
      </h6>
      <p
        i18n="@@loginView.emailSentView.linkSentText"
        class="u-marginBottom-16 color-grey-300 u-wordWrap-breakWord"
      >
        The link sent to
        <span class="color-black">{{ loginForm.value.email }}</span> will expire
        in 60 minutes.
      </p>
      <p
        i18n="@@loginView.emailSentView.sendLinkPrompt"
        class="u-marginBottom-16 color-grey-300"
      >
        If you didn't get the email, select the button below to try a new
        address.
      </p>
      <div
        class="u-padding-0-16 u-paddingBottom-16"
        fxLayout="row"
        fxLayoutAlign="end center"
      >
        <button
          i18n="@@loginView.emailSentView.resetCta"
          mat-raised-button
          color="primary"
          (click)="reset()"
        >
          Try Again
        </button>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-template #createAccountErrorTemplate>
  <p i18n="@@confirmPromptDialog.content.createAccount">
    We didn't find an account for <b>{{ loginForm.value.email }}</b
    >. Did you mean to create an account instead?
  </p>
</ng-template>
